import UNIFIED_E_HEALTH from '../assets/UNIFIED E-HEALTH.jpg';
import HOSPITAL_MANAGEMENT from '../assets/HOSPITAL MANAGEMENT.jpg';
import POLYCLINIC_MANAGEMENT from '../assets/POLYCLINIC MANAGEMENT.jpg';
import ENTERPRISE_IMAGING from '../assets/ENTERPRISE IMAGING.jpg';
import RADIOLOGY_MANAGEMENT from '../assets/RADIOLOGY MANAGEMENT.jpg';
import LAB_MANAGEMENT from '../assets/LAB MANAGEMENT.jpg';
import CARDIOLOGY from '../assets/CARDIOLOGY.jpg';
import GASTROENTROLOGY from '../assets/GASTROENTROLOGY.jpg';
// import WOMEN_IMAGING from '../assets/WOMEN IMAGING.jpg';
import DERMATOLOGY from '../assets/DERMATOLOGY.jpg';
import DENTAL_IMAGING from '../assets/DENTAL IMAGING.jpg';
// import ONCOLOGY_IMAGING from '../assets/ONCOLOGY IMAGING.jpg';
import HOME_CARE from '../assets/HOME CARE.jpg';
import TELE_MEDICINCE from '../assets/TELE MEDICINCE.jpg';
import MOBILE_HEALTH from '../assets/MOBILE HEALTH.jpg';
import FINANCIAL_MANAGEMENT from '../assets/FINANCIAL MANAGEMENT.jpg';
import INVENTORY_MANAGEMENT from '../assets/INVENTORY MANAGEMENT.jpg';
import HUMAN_CAPITAL_MANAGEMENT from '../assets/HUMAN CAPITAL MANAGEMENT.jpg';
//================================
import eHealth from '../assets/New folder/1.jpg';
import EHR_HMIS from '../assets/New folder/2.jpg';
import EMR from '../assets/New folder/3.jpg';
import RIS from '../assets/New folder/4.jpg';
import LIS from '../assets/New folder/5.jpg';
import Telemedicine from '../assets/New folder/6.jpg';
//--------------------------------------------------------------
import VNA from '../assets/New folder/2-1.jpg';
import PACS from '../assets/New folder/2-2.jpg';
import PACS_Viewer from '../assets/New folder/2-3.jpg';
import Teleradiology from '../assets/New folder/2-4.jpg';
import Disc_Publisher from '../assets/New folder/2-5.gif';
import DICOM_Print from '../assets/New folder/2-6.gif';
//--------------------------------------------------------------------
import ERP from '../assets/New folder/3-1.jpg';
import Financials from '../assets/New folder/3-2.jpg';
import Inventory from '../assets/New folder/3-3.jpg';
import HRM from '../assets/New folder/3-4.jpg';
import CRM from '../assets/New folder/3-5.jpg';
//===============================
import Radiology from '../assets/New folder/4-1.jpg'
// import Women_Health from '../assets/New folder/4-2.jpg'
import Cardiology from '../assets/New folder/4-3.jpg'
import Gastroentrology from '../assets/New folder/4-4.jpg'
// import Oncology from '../assets/New folder/4-5.jpg'
import Dental from '../assets/New folder/4-6.jpg'
import Dermatology from '../assets/New folder/4-7.jpg'
//=========================================
import Mobile_Applications from '../assets/New folder/5-1.jpg';
import Business_Intelligence from '../assets/New folder/5-2.jpg';
import Integration from '../assets/New folder/5-3.gif';
import DICOM_Viewer_2 from '../assets/New folder/5-4.gif';
//--------------------------------------------
import ERP_2 from '../assets/New folder/6-1.jpg' ;
import FINANCIALS from '../assets/New folder/6-2.jpg' ;
import INVENTORY from '../assets/New folder/6-3.jpg' ;
import HUMAN_RESOURCES from '../assets/New folder/6-4.jpg' ;
import CRM_2 from '../assets/New folder/6-5.jpg' ;
import ANALYTICS from '../assets/New folder/6-6.jpg' ;
//=================================



export const products = [
    {
        title : 'Modular Enterprise Healthcare Platform',
        img : UNIFIED_E_HEALTH,
        description : 'Achieve operation excellence in the healthcare enterprise with the unified management platform.',
        to:'/',
    },
    {
        title : 'HOSPITAL MANAGEMENT',
        img : HOSPITAL_MANAGEMENT ,
        description : 'Leverage productivity and increase profitability of the healthcare organization with MILLENSYS HIS and ERP.',
        to:'/',
    },
    {
        title : 'POLYCLINIC MANAGEMENT',
        img : POLYCLINIC_MANAGEMENT,
        description : 'Manage the whole polyclinic with a single solution including web based scalable EMR solution and financial ERP financial .',
        to:'/',
    },
    {
        title : 'ENTERPRISE IMAGING',
        img : ENTERPRISE_IMAGING,
        description : 'Archive, view and share images and documents across the enterprise with MILLENSYS Vendor Neutral Archive VNA.',
        to:'/',
    },
    {
        title : 'RADIOLOGY MANAGEMENT',
        img : RADIOLOGY_MANAGEMENT,
        description : 'Achieve operation excellence in radiology with MILLENSYS unified RIS and PACS solution including a complete ERP .',
        to:'/',
    },
    {
        title : 'LAB MANAGEMENT',
        img : LAB_MANAGEMENT,
        description : 'Manage the laboratory and increase profitability with MILLENSYS LIS , with instrument automation and a financial ERP.',
        to:'/',
    },
    {
        title : 'CARDIOLOGY',
        img : CARDIOLOGY,
        description : 'Achieve operation excellence in cardiology with MILLENSYS unified EMR and VNA solution including a financial  ERP',
        to:'/',
    },
    {
        title : 'GASTROENTROLOGY',
        img : GASTROENTROLOGY,
        description : 'Endoscopy image acquisition and reporting plus a full EMR and ERP application to manage gastroentrology departments',
        to:'/',
    },
    // {
    //     title : 'WOMEN IMAGING',
    //     img : WOMEN_IMAGING,
    //     description : 'Unified Solution of EMR / RIS and Mammography PACS to manage a women imaging department including ERP solution',
    //     to:'/',
    // },
    {
        title : 'DERMATOLOGY',
        img : DERMATOLOGY,
        description : 'EMR Solution to manage dermatology or clinical department including financial ERP solution',
        to:'/',
    },
    {
        title : 'DENTAL IMAGING',
        img : DENTAL_IMAGING,
        description : 'Dental PACS and EMR Solution to manage dental department including complete financial ERP solution',
        to:'/',
    },
    // {
    //     title : 'ONCOLOGY IMAGING',
    //     img : ONCOLOGY_IMAGING,
    //     description : 'Unified Solution of EMR / RIS and PET / CT and nuclear medicine PACS to manage an oncology department plus financial ERP',
    //     to:'/',
    // },
    {
        title : 'HOME CARE',
        img : HOME_CARE,
        description : 'Unified home care software solution for healthcare providers',
        to:'/',
    },
    {
        title : 'TELE MEDICINCE',
        img : TELE_MEDICINCE,
        description : 'Unified telemedicine software solution for remote tele-consultation services.',
        to:'/',
    },
    {
        title : 'MOBILE HEALTH',
        img : MOBILE_HEALTH,
        description : 'Patient Engagement mobile application for patients, physicians and management team',
        to:'/',
    },
    {
        title : 'FINANCIAL MANAGEMENT',
        img : FINANCIAL_MANAGEMENT,
        description : 'Powerful financial management ERP solution',
        to:'/',
    },
    {
        title : 'INVENTORY MANAGEMENT',
        img : INVENTORY_MANAGEMENT,
        description : 'Powerful Inventory and supply chain Management solution',
        to:'/',
    },
    {
        title : 'HUMAN CAPITAL MANAGEMENT',
        img : HUMAN_CAPITAL_MANAGEMENT,
        description : 'Powerful Human Resources " HR " Management solution',
        to:'/',
    },
]

export const productsHealthcare = [
    {
        title : 'Modular Enterprise Healthcare Platform',
        img : UNIFIED_E_HEALTH,
        description : 'Achieve operation excellence in the healthcare enterprise with the unified management platform.',
        to:'/',
    },
    {
        title : 'HOSPITAL MANAGEMENT',
        img : HOSPITAL_MANAGEMENT ,
        description : 'Leverage productivity and increase profitability of the healthcare organization with MILLENSYS HIS and ERP.',
        to:'/',
    },
    {
        title : 'POLYCLINIC MANAGEMENT',
        img : POLYCLINIC_MANAGEMENT,
        description : 'Manage the whole polyclinic with a single solution including web based scalable EMR solution and financial ERP financial .',
        to:'/',
    },
    {
        title : 'ENTERPRISE IMAGING',
        img : ENTERPRISE_IMAGING,
        description : 'Archive, view and share images and documents across the enterprise with MILLENSYS Vendor Neutral Archive VNA.',
        to:'/',
    },
    {
        title : 'RADIOLOGY MANAGEMENT',
        img : RADIOLOGY_MANAGEMENT,
        description : 'Achieve operation excellence in radiology with MILLENSYS unified RIS and PACS solution including a complete ERP .',
        to:'/',
    },
    {
        title : 'LAB MANAGEMENT',
        img : LAB_MANAGEMENT,
        description : 'Manage the laboratory and increase profitability with MILLENSYS LIS , with instrument automation and a financial ERP.',
        to:'/',
    },
    {
        title : 'CARDIOLOGY',
        img : CARDIOLOGY,
        description : 'Achieve operation excellence in cardiology with MILLENSYS unified EMR and VNA solution including a financial  ERP',
        to:'/',
    },
    {
        title : 'GASTROENTROLOGY',
        img : GASTROENTROLOGY,
        description : 'Endoscopy image acquisition and reporting plus a full EMR and ERP application to manage gastroentrology departments',
        to:'/',
    },
    // {
    //     title : 'WOMEN IMAGING',
    //     img : WOMEN_IMAGING,
    //     description : 'Unified Solution of EMR / RIS and Mammography PACS to manage a women imaging department including ERP solution',
    //     to:'/',
    // },
    {
        title : 'DERMATOLOGY',
        img : DERMATOLOGY,
        description : 'EMR Solution to manage dermatology or clinical department including financial ERP solution',
        to:'/',
    },
    {
        title : 'DENTAL IMAGING',
        img : DENTAL_IMAGING,
        description : 'Dental PACS and EMR Solution to manage dental department including complete financial ERP solution',
        to:'/',
    },
    // {
    //     title : 'ONCOLOGY IMAGING',
    //     img : ONCOLOGY_IMAGING,
    //     description : 'Unified Solution of EMR / RIS and PET / CT and nuclear medicine PACS to manage an oncology department plus financial ERP',
    //     to:'/',
    // },
    {
        title : 'TELE MEDICINCE',
        img : TELE_MEDICINCE,
        description : 'Unified telemedicine software solution for remote tele-consultation services.',
        to:'/',
    },
    {
        title : 'MOBILE HEALTH',
        img : MOBILE_HEALTH,
        description : 'Patient Engagement mobile application for patients, physicians and management team',
        to:'/',
    },
    {
        title : 'FINANCIAL MANAGEMENT',
        img : FINANCIAL_MANAGEMENT,
        description : 'Powerful financial management ERP solution',
        to:'/',
    },
]
export const products_1 = [
    {
        title : 'eHealth',
        title_2 : 'Modular Enterprise Healthcare Platform',
        img : eHealth,
        to:'/',
    },
    {
        title : 'EHR / HMIS',
        img : EHR_HMIS,
        to:'/',
    },
    {
        title : 'EMR',
        img : EMR,
        to:'/',
    },
    {
        title : 'RIS',
        img : RIS,
        to:'/',
    },
    {
        title : 'LIS',
        img : LIS,
        to:'/',
    },
    {
        title : 'Telemedicine',
        title_2 : 'TELE MEDICINCE',
        img : Telemedicine,
        to:'/',
    },
]
export const products_2 = [
    {
        title : 'VNA',
        title_2 : 'ENTERPRISE IMAGING',
        img : VNA,
        to:'/',
    },
    {
        title : 'PACS',
        img : PACS,
        to:'/',
    },
    {
        title : 'PACS Viewer',
        img : PACS_Viewer,
        to:'/',
    },
    {
        title : 'Teleradiology',
        img : Teleradiology,
        to:'/',
    },
    {
        title : 'Disc Publisher',
        img : Disc_Publisher,
        to:'/',
    },
    {
        title : 'DICOM Print',
        img : DICOM_Print,
        to:'/',
    },
]
export const products_3 = [
    {
        title : 'ERP',
        title_2 : 'FINANCIAL MANAGEMENT',
        img : ERP,
        to:'/',
    },
    {
        title : 'Financials',
        img : Financials,
        to:'/',
    },
    {
        title : 'Inventory',
        title_2 : 'INVENTORY MANAGEMENT',
        img : Inventory,
        to:'/',
    },
    {
        title : 'HRM',
        title_2 : 'HUMAN CAPITAL MANAGEMENT',
        img : HRM,
        to:'/',
    },
    {
        title : 'CRM',
        img : CRM,
        to:'/',
    },
]
export const products_4 = [
    {
        title : 'Radiology',
        title_2 : 'RADIOLOGY MANAGEMENT',
        img : Radiology,
        to:'/',
    },
    // {
    //     title : 'Women Health',
    //     img : Women_Health,
    //     to:'/',
    // },
    {
        title : 'Cardiology',
        title_2 : 'CARDIOLOGY',
        img : Cardiology,
        to:'/',
    },
    {
        title : 'Gastroentrology',
        title_2 : 'GASTROENTROLOGY',
        img : Gastroentrology,
        to:'/',
    },
    // {
    //     title : 'Oncology',
    //     img : Oncology,
    //     to:'/',
    // },
    {
        title : 'Dental',
        title_2 : 'DENTAL IMAGING',
        img : Dental,
        to:'/',
    },
    {
        title : 'Dermatology',
        title_2 : 'DERMATOLOGY',
        img : Dermatology,
        to:'/',
    },
]
export const products_5 = [
    {
        title : 'Mobile Applications',
        title_2 : 'MOBILE HEALTH',
        img : Mobile_Applications,
        to:'/',
    },
    {
        title : 'Business Intelligence',
        img : Business_Intelligence,
        to:'/',
    },
    {
        title : 'Integration',
        img :Integration ,
        to:'/',
    },
    {
        title : 'DICOM Viewer',
        img : DICOM_Viewer_2,
        to:'/',
    },
]
export const productsLnding = [
    {
        title : 'PACS',
        img : PACS,
        to:'/',
    },
    {
        title : 'RIS',
        img : RIS,
        to:'/',
    },
    {
        title : 'Teleradiology',
        img : Teleradiology,
        to:'/',
    },
    {
        title : 'VNA',
        title_2 : 'ENTERPRISE IMAGING',
        img : VNA,
        to:'/',
    },
    {
        title : 'POLYCLINIC MANAGEMENT',
        img : POLYCLINIC_MANAGEMENT,
        to:'/',
    },
    {
        title : 'Mobile Applications',
        title_2 : 'MOBILE HEALTH',
        img : Mobile_Applications,
        to:'/',
    },
]
export const productsLnding_pacs_ris = [
    {
        title : 'PACS',
        img : PACS,
        to:'/',
    },
    {
        title : 'RIS',
        img : RIS,
        to:'/',
    },
]
export const productsLnding_polyclinic_erp = [
    {
        title : 'ERP',
        title_2 : 'FINANCIAL MANAGEMENT',
        img : ERP_2,
        to:'/',
    },
    {
        title : 'POLYCLINIC MANAGEMENT',
        img : POLYCLINIC_MANAGEMENT,
        to:'/',
    },
]


export const productsCommercial = [
    {
        title : 'ERP',
        title_2 : 'FINANCIAL MANAGEMENT',
        img : ERP_2,
        description : 'All in one web based software application to manager financials , inventory and human resources for the enterprise.',
        to:'/',
    },
    {
        title : 'FINANCIALS',
        title_2 : "Financials",
        img : FINANCIALS,
        description : 'Financial Management web module to manage costs, account receivables and assets of the organization.',
        to:'/',
    },
    {
        title : 'INVENTORY MANAGEMENT',
        img : INVENTORY,
        description : 'Manage multiple Inventories, supply chain, purchasing and account payables with a powerful web based software module.',
        to:'/',
    },
    {
        title : 'HUMAN RESOURCES',
        title_2 : 'HUMAN CAPITAL MANAGEMENT',
        img : HUMAN_RESOURCES,
        description : 'Manage Employees time attendance , payroll , training and appraisals with a powerful web based HRM application ',
        to:'/',
    },
    {
        title : 'CRM',
        img : CRM_2,
        description : 'Manage sales funnel , quotations , service tickets and installation base , marketing email campains .',
        to:'/',
    },
    {
        title : 'ANALYTICS',
        title_2 : 'Business Intelligence',
        img : ANALYTICS,
        description : 'Business Intelligence web based tool to monitor KPIs and build dashboards all over the solution',
        to:'/',
    },
]

